import { BillingAddress, PricingInformation } from '@platform-frontend/marketplace';

export class StashCountrySelectionForConfirmation {
  static readonly type = '[SubscriptionBilling] Stash country selection for confirmation';
  constructor(public countryCode: string) {}
}

export class StashBillingAddressSelectionForConfirmation {
  static readonly type = '[SubscriptionBilling] Stash billing address selection for confirmation';
  constructor(public billingAddressId: number | 'NONE') {}
}

export class StashBillingAddressUpdateForConfirmation {
  static readonly type = '[SubscriptionBilling] Stash billing address update for confirmation';
  constructor(public billingAddress: BillingAddress) {}
}

export class StashBillingAddressDeletionForConfirmation {
  static readonly type = '[SubscriptionBilling] Stash billing address deletion for confirmation';
}

export class ConfirmStashedBillingAddress {
  static readonly type = '[SubscriptionBilling] Confirm stashed billing address';
  constructor(public gotoFlowStart: boolean = false) {}
}

export class ConnectBillingAddress {
  static readonly type = '[SubscriptionBilling] Connect billing address';
  constructor(public billingAddressId: number, public pricingInformation: PricingInformation) {}
}

export class UnconnectBillingAddress {
  static readonly type = '[SubscriptionBilling] Unconnect billing address';
  constructor(public countryCode: string, public pricingInformation: PricingInformation) {}
}

export class ResetStashedBillingAddress {
  static readonly type = '[SubscriptionBilling] Reset stashed billing address';
}
